import loader from '../moduleLoader';
import shave from 'shave';

class Ellipsis {
    constructor(container) {
        this.container = container;
        this.matches = this.matches.bind(this);
    }

    init() {
        var media = window.matchMedia('(max-width: 1024px)');
        this.matches(media);
        media.addListener(this.matches);
    }

    matches(media) {
        if (media.matches) {     
            /*shave(this.container, 90);  */     
        } else {            
            /*shave(this.container, 120);*/
        }
    }
}

loader.add('Ellipsis', Ellipsis);
export default Ellipsis;